var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 29.4167H26.5M19.5 15.6667H28.5C28.9667 15.6667 29.2001 15.6667 29.3783 15.7575C29.5351 15.8374 29.6626 15.9649 29.7425 16.1217C29.8333 16.2999 29.8333 16.5333 29.8333 17V18.7288C29.8333 19.1364 29.8333 19.3402 29.7873 19.532C29.7465 19.7021 29.6791 19.8647 29.5877 20.0138C29.4847 20.182 29.3405 20.3261 29.0523 20.6144L26.6095 23.0572C26.2795 23.3872 26.1145 23.5522 26.0526 23.7425C25.9982 23.9098 25.9982 24.0901 26.0526 24.2575C26.1145 24.4478 26.2795 24.6128 26.6095 24.9428L29.0523 27.3856C29.3405 27.6739 29.4847 27.818 29.5877 27.9862C29.6791 28.1353 29.7465 28.2979 29.7873 28.4679C29.8333 28.6597 29.8333 28.8636 29.8333 29.2712V31C29.8333 31.4667 29.8333 31.7001 29.7425 31.8783C29.6626 32.0351 29.5351 32.1626 29.3783 32.2425C29.2001 32.3333 28.9667 32.3333 28.5 32.3333H19.5C19.0333 32.3333 18.7999 32.3333 18.6217 32.2425C18.4649 32.1626 18.3374 32.0351 18.2575 31.8783C18.1667 31.7001 18.1667 31.4667 18.1667 31V29.2712C18.1667 28.8636 18.1667 28.6597 18.2127 28.4679C18.2535 28.2979 18.3209 28.1353 18.4123 27.9862C18.5153 27.818 18.6595 27.6739 18.9477 27.3856L21.3905 24.9428C21.7205 24.6128 21.8855 24.4478 21.9474 24.2575C22.0017 24.0901 22.0017 23.9098 21.9474 23.7425C21.8855 23.5522 21.7205 23.3872 21.3905 23.0572L18.9477 20.6144C18.6595 20.3261 18.5153 20.182 18.4123 20.0138C18.3209 19.8647 18.2535 19.7021 18.2127 19.532C18.1667 19.3402 18.1667 19.1364 18.1667 18.7288V17C18.1667 16.5333 18.1667 16.2999 18.2575 16.1217C18.3374 15.9649 18.4649 15.8374 18.6217 15.7575C18.7999 15.6667 19.0333 15.6667 19.5 15.6667Z",
    stroke: "#FBB624",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogress);
export default __webpack_public_path__ + "static/media/inprogress.87aa80afe1544a005ee8138bd14210ce.svg";
export { ForwardRef as ReactComponent };